import { ADD_ASSURED,ADD_CONTRATANT, REMOVE_ASSURED, REMOVE_ALL, ADD_ID_PROSPECTO, UPDATE_ASSURED, UPDATE_CONTRATANT, ADD_REP_LEGAL} from "./actions";

const initialState = {
};

const dataReducer = (state = initialState, action) => {
    const {
        type, 
        contratant, 
        assured,
        newAssured,
        newContratant,
        idProspecto,
        repLegal
    } = action;
  
    switch (type) {
        case ADD_ASSURED:
            return { 
                ...state, 
                assured
            };
        // case UPDATE_ASSURED:
        //     return { 
        //         ...state,
        //         assured
        //     } 
        case ADD_CONTRATANT:{
            return { 
                ...state, 
                contratant
            };
        }
        case ADD_ID_PROSPECTO:
            return { 
                ...state, 
                contratant,
                assured,
                idProspecto
            };
        case REMOVE_ASSURED:{
            return {
                ...state, assured:{}
            };
        }
        case REMOVE_ALL:{
            return {
                ...state,
                assured:{},
                contratant:{},
                repLegal:{}
            };
        }
        case UPDATE_ASSURED:{
            const newStateAssured = Object.assign(assured, newAssured)
           
            return {...state, assured:Object.assign(newStateAssured, state.assured)}
        }
        case UPDATE_CONTRATANT:{
            const newStateContratant = Object.assign(contratant, newContratant)
           
            return {...state, contratant:Object.assign(newStateContratant, state.contratant)}
        }
        default:{
            return state;
        }
        case ADD_REP_LEGAL:{
            return {
                ...state,
                repLegal
            }
        }
    }
};

export default dataReducer;
